<template>
  <div>
    <el-button type="primary" @click="pint">打印唛头</el-button>
    <!--给配货打印  -->
    <!-- EMS打印 -->
    <div v-show="false">
      <div ref="EMSprintingmark" v-if="logistics == 'EMS' || logistics == 'EMS船便'">
        <EMSprintingmark />
      </div>
    </div>
    <!-- OCS打印 -->
    <div v-show="false">
      <!-- 授权 -->
      <div ref="OCSCustomerShippingmark" v-if="logistics == 'OCS' && is_authorized">
        <OCSCustomerShippingmark />
      </div>
      <!-- 没授权的 -->
      <div ref="OCSCustomerShippingmark" v-if="logistics == 'OCS' && !is_authorized">
        <OCSShippingmark />
      </div>
    </div>
    <!-- TW打印 -->
    <div v-show="false">
      <!-- 授权 -->
      <div ref="TWCustomerShippingmark" v-if="logistics == 'TW船便' &&
        is_authorized">
        <TWCustomerShippingmark />
      </div>
      <!-- 没授权的 -->
      <div ref="TWCustomerShippingmark" v-if="logistics == 'TW船便' &&
        !is_authorized">
        <TWCustomerShippingmarkNormal />
      </div>
    </div>
    <!-- DQ打印 -->
    <div v-show="false">
      <!-- 授权 -->
      <div ref="DQShippingmark" v-if="(allowedLogistics.includes(logistics) && is_authorized)">
        <DQCustomerShippingmark />
      </div>
      <!-- 没授权的 -->
      <div ref="DQShippingmark" v-if="(allowedLogistics.includes(logistics) && !is_authorized)">
        <DQShippingmark />
      </div>
    </div>
    <!-- KS-JP航空便 KS-JP航空経済便-->
    <div v-show="false">
      <div ref="KS_JPShippingmark"
        v-if="logistics == 'KS-JP航空便' || logistics == 'KS-JP航空経済便' || logistics == 'KS-JP電子特殊便'">
        <!-- v-for="(item, index) in printData" :key="index" :datas="item"  -->
        <KS_JPShippingmark />
      </div>
    </div>

    <!-- RW船便 -->
    <div v-show="false" v-if="logistics == 'RW船便'">
      <div ref="RWCustomerShippingmark">
        <RWCustomerShippingmark />
      </div>
    </div>
    <!-- Raku_DQ -->
    <div v-show="false" v-if="logistics == 'Raku-DQ'">
      <div ref="Raku_DQShippingmark">
        <Raku_DQShippingmark />
      </div>
    </div>
  </div>
</template>
<script>
import KS_JPShippingmark from "@/components/Printedsheet/KS_JPShippingmark.vue";
import RWCustomerShippingmark from "@/components/Printedsheet/RWCustomerShippingmark.vue";
import Raku_DQShippingmark from "@/components/Printedsheet/Raku-DQShippingmark";
import EMSprintingmark from "@/components/Printedsheet/EMSprintingmark";
import TWCustomerShippingmark from "@/components/Printedsheet/TWCustomerShippingmark";
import TWCustomerShippingmarkNormal from "@/components/Printedsheet/TWCustomerShippingmarkNormal";
import OCSCustomerShippingmark from "@/components/Printedsheet/OCSCustomerShippingmark";
import OCSShippingmark from "@/components/Printedsheet/OCSShippingmark";
import DQShippingmark from "@/components/Printedsheet/DQShippingmark";
import DQCustomerShippingmark from "@/components/Printedsheet/DQCustomerShippingmark";
import { mapState } from 'vuex'
export default {
  components: {
    KS_JPShippingmark,
    RWCustomerShippingmark,
    Raku_DQShippingmark,
    EMSprintingmark,
    TWCustomerShippingmark,
    TWCustomerShippingmarkNormal,
    OCSCustomerShippingmark,
    OCSShippingmark,
    DQShippingmark,
    DQCustomerShippingmark,
  },
  computed: {
    ...mapState({
      logistics: (state) => state.porderDetail.logistics, //要打印的物流方式
      printData: (state) => state.porderDetail.printData, //要打印的数据

    }),
  },
  data() {
    return {
      is_authorized: false,
      allowedLogistics: [
        '海源DQ船便',
        'コンテナ',
        'お任せ(お勧め)',
        '電子特殊便',
        'その他',
        'FBA新幹線',
        '海源TK船便',
        '海源 LCLコンテナ混載便',
        '海源電子特殊航空便',
        'Rロジ専用船便'
      ]
    };
  },
  mounted() {
    // this.pint()
  },
  methods: {
    //打印
    pint() {
      let query = this.$route.query
      let logistics = query.logistics
      let freightIds = query.freightIds.split(',')


      if (logistics == 'KS-JP航空便' || logistics == 'KS-JP航空経済便' || logistics == 'KS-JP電子特殊便') {
        this.$api.porderApi.kilospeedMark({ freightIds }).then(res => {
          let porder_md5 = this.$md5(res.data[0].porder_sn)
          if (porder_md5 != query.porder_md5) return this.$message.error('非法打印，请联系业务员')
          res.data.forEach((item, index) => {
            item.num = index + 1
            item.show = false
            item.logistics = logistics
          })
          // 排序
          res.data.sort(function (a, b) {
            return a.number_by_express_no - b.number_by_express_no;
          });
          let datas = {
            logistics,
            printData: res.data,
            is_authorized: res.data[0].is_authorized
          }
          this.is_authorized = res.data[0].is_authorized
          this.$store.commit('setPrintData', datas)
          setTimeout(() => {
            this.$print(this.$refs.KS_JPShippingmark);
            this.$store.commit('setPrintData', {})
          }, 1000)
        })
      } else {
        this.$api.getMaitouData({ freightIds }).then(res => {
          let porder_md5 = this.$md5(res.data[0].porder_sn)
          if (porder_md5 != query.porder_md5) return this.$message.error('非法打印，请联系业务员')
          res.data.forEach((item, index) => {
            item.num = index + 1
          })
          // 排序
          res.data.sort(function (a, b) {
            return a.number_by_express_no - b.number_by_express_no;
          });
          let datas = {
            logistics,
            printData: res.data,
            is_authorized: res.data[0].is_authorized
          }
          this.is_authorized = res.data[0].is_authorized
          this.$store.commit('setPrintData', datas)
          if (logistics == 'EMS' || logistics == 'EMS船便') {
            this.$nextTick(() => {
              this.$print(this.$refs.EMSprintingmark);
              this.$store.commit('setPrintData', {})
              this.$forceUpdate()
            });
          } else if (logistics == 'TW船便') {
            this.$nextTick(() => {
              this.$print(this.$refs.TWCustomerShippingmark);
              this.$store.commit('setPrintData', {})
              this.$forceUpdate()
            });
          } else if (logistics == 'RW船便') {
            this.$nextTick(() => {
              this.$print(this.$refs.RWCustomerShippingmark);
              this.$store.commit('setPrintData', {})
              this.$forceUpdate()
            });
          }
          else if (logistics == 'Raku-DQ') {
            this.$nextTick(() => {
              this.$print(this.$refs.Raku_DQShippingmark);
              this.$store.commit('setPrintData', {})
              this.$forceUpdate()
            });
          }
          else if (logistics == 'OCS') {
            this.$nextTick(() => {
              this.$print(this.$refs.OCSCustomerShippingmark);
              this.$store.commit('setPrintData', {})
              this.$forceUpdate()
            });
          } else {
            this.$nextTick(() => {
              this.$print(this.$refs.DQShippingmark);
              this.$store.commit('setPrintData', {})
              this.$forceUpdate()
            });
          }
        })
      }
    },
  }
}
</script>
<style lang='scss' scoped>
.el-button {
  margin: 30px;
}
</style>